import { versionedStyleConfig } from '@joinrepublic/dls-ui-core';

import { styleConfig as v2_1 } from './2.1';
import { styleConfig as v2_2 } from './2.2';

export const styleConfig = versionedStyleConfig({
  current: v2_2,
  previous: { version: '2.1', config: v2_1 },
});
